import { render, staticRenderFns } from "./metricCard.vue?vue&type=template&id=568dc295&scoped=true"
import script from "./metricCard.vue?vue&type=script&lang=js"
export * from "./metricCard.vue?vue&type=script&lang=js"
import style0 from "./metricCard.vue?vue&type=style&index=0&id=568dc295&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568dc295",
  null
  
)

export default component.exports